import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'

const SITE_URL = 'https://sabraah.com'
const DEFAULT_IMAGE = `${SITE_URL}/favicon.webp`

const Seo = ({ title, description, path = '/', image = DEFAULT_IMAGE, jsonLd }) => {
  const url = `${SITE_URL}${path}`

  useEffect(() => {
    if (!jsonLd) return undefined

    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.text = JSON.stringify(jsonLd)
    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [jsonLd])

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content="SabRaah" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="SabRaah" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}

export default Seo
